import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbConviteVirtual } from 'app/abstract/full-pages/convite-virtual/convite-virtual.abstract';
import {
  ConviteVirtualResponse,
  ConviteVirtualUpdateRequest
} from './convite-virtual.models';

const ENDPOINT = 'api/v1/convite-virtual';

@Injectable({ providedIn: 'root' })
export class ConviteVirtualService extends AbConviteVirtual {

  constructor(http: HttpClient) {
    super(http);
  }

  public buscar(): Observable<ConviteVirtualResponse> {
    return this.get<ConviteVirtualResponse>(ENDPOINT);
  }

  public atualizar(
    request: ConviteVirtualUpdateRequest
  ): Observable<ConviteVirtualResponse> {
    return this.http.put<ConviteVirtualResponse>(`${this.url}${ENDPOINT}`, request);
  }
}
